import React from "react";
import PropTypes from "prop-types";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;

const Calender = ({ handleChange, defaultValue, value }) => {
  return (
    <RangePicker
      onChange={handleChange}
      defaultValue={defaultValue}
      value={value}
      format="DD-MM-YYYY"
      style={{ width: '100%' }}
    />
  );
};

Calender.propTypes = {
  handleChange: PropTypes.func,
  defaultValue: PropTypes.any,
  value: PropTypes.any,
};

export { Calender };
